<template>
    <div
        v-if="newsletter && newsletter.show"
        class="tw-bg-cover tw-bg-center tw-bg-no-repeat"
        :style="{ backgroundImage: `url(${bgImage})` }">
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-py-24 tw-max-w-[900px] tw-px-8 tw-mx-auto">
            <h1
                class="tw-mb-8 tw-text-center tw-text-2xl lg:tw-text-4xl"
                v-html="newsletter.title"></h1>
            <p
                class="tw-mb-12 tw-text-center tw-text-base lg:tw-text-lg"
                v-html="newsletter.text"></p>
            <div class="tw-flex tw-w-full lg:tw-max-w-[600px] tw-max-w-[400px] tw-flex-col lg:tw-flex-row tw-gap-4 lg:tw-gap-0 tw-items-center">
                <v-text-field
                    class="newsletter-input lg:tw-h-14 tw-h-12 tw-w-full"
                    flat
                    placeholder="Email"
                    rounded="pill"
                    type="email"
                    variant="solo">
                    <template #append-inner>
                            <v-btn
                                class="tw-h-full max-lg:tw-w-min tw-rounded-l-none"
                                color="primary"
                                elevation="0"
                                flat
                                rounded="pill"
                                @click="onSubscribe">
                                <span class="tw-text-sm tw-font-light lg:tw-text-base max-lg:tw-hidden" v-html="newsletter.buttonText"></span>
                                <v-icon class="tw-text-xl lg:tw-hidden">mdi-arrow-top-right</v-icon>
                            </v-btn>
                        </template>
                </v-text-field>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useAppStore } from '@/store/app';
    import { useMedia } from '@/composables/useMedia';

    const appStore = useAppStore();

    const newsletter = computed(() => {
        return appStore.getNewsletter;
    });
    const bgImage = computed(() => {
        if (!newsletter.value?.background) return '';
        return useMedia(newsletter.value?.background).medium;
    });

    const onSubscribe = () => {
        console.log('onSubscribe');
    };
</script>

<style lang="scss">

</style>
